/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createString } from '../../factoriesAny.js';
export var stringDependencies = {
  typedDependencies,
  createString
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesString.generated.js
// module id = null
// module chunks = 